import { ValidatorBase } from './ValidatorBase'
import { StringUtils } from '../../../Utils/StringUtils';

export class EmailValidator extends ValidatorBase {

    public constructor(message: string, data: string) {
        super(message, data);
    }

    public validate(value: string, messages: string[]) {
        var regex = /(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        if (!regex.test(value)) {
            let msg = StringUtils.isNullOrEmpty(this._message) ? "Value is not a valid email address." : this._message;
            messages.push(msg);
        }
    }

}


/** WEBPACK FOOTER **
 ** ./Typescript/Components/ConfigurationPanel/Validators/EmailValidator.ts
 **/